<template>
  <div id="Activate">
    <div class="content1">
      <p class="title">后台用户激活</p>
      <p class="line-gray"></p>
      <div class="rzData1">
        <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
          <el-form-item label="温馨提示：" class="Danger">
            <p class="info">带  <span class="red">*</span>  的为必填项</p>
          </el-form-item>
          <el-form-item label="注册邮箱：" class="blue">
            {{ ruleForm2.emil }}
          </el-form-item>
          <el-form-item label="手机号码：" class="is-required" prop="phonenumber">
            <el-input v-model="ruleForm2.phonenumber"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名：" class="is-required" prop="name">
            <el-input v-model="ruleForm2.name"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="pass" class="is-required">
            <el-input type="password" v-model="ruleForm2.pass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="checkPass" class="is-required">
            <el-input type="password" v-model="ruleForm2.checkPass" autocomplete="off"></el-input>
          </el-form-item>
          <br/>
          <el-form-item style="margin-left: 100px;margin-top: 15px;">
            <el-button type="success" style="width: 120px;" @click="submitForm('ruleForm2')">激活</el-button>
          </el-form-item>
        </el-form>

      </div>
    </div>
    <el-dialog class="rzData1 loginBord" title="提示" :visible.sync="dialogFormVisibledl">
      <h2>{{ errorMessage }}</h2>
      <p>系统{{ loadTime }}后自动登录</p>
      <p style="font-size: 14px;">如无跳转，<a href="javascript:;" @click="jumpAut">点此登录</a></p>

      <!--<div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibledl = false">取 消</el-button>
        <el-button type="primary" @click="">确 定</el-button>
      </div>-->
    </el-dialog>
  </div>
</template>

<script>
  import 'element-ui/lib/theme-chalk/index.css';

  export default {
    name: "Activate",
    data() {
      var checkName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('姓名不能为空'));
        }
        setTimeout(() => {
          if (value.length> 20) {
            callback(new Error('字段长度过长'));
          } else {
            callback();
          }
        }, 1000);
      };
      var phone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号码不能为空'));
        }

        var isPhone = /^1[3|4|5|6|7|8|9][0-9]{9}$/;

        // var isMob = /^0?1[3|4|5|8][0-9]\d{8}$/;// 座机格式
        if (isPhone.test(value)) {
          callback();
        } else {
          callback(new Error('手机号码格式错误'));
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          var par = /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/;

          if (value.length < 4 || value.length > 16 || !par.test(value)) {
            callback(new Error('请输入4-16位密码，必须包含数字、字母，不能为空格'));
          }
          if (this.ruleForm2.checkPass !== '') {
            this.$refs.ruleForm2.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm2.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        dialogFormVisibledl:false,
        loadTime:3,
        errorMessage:'',
        ruleForm2: {
          emil:'',
          activecode:'',
          pass: '',
          checkPass: '',
          name: '',
          phonenumber:''
        },
        rules2: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          name: [
            { validator: checkName, trigger: 'blur' }
          ],
          phonenumber: [
            { validator: phone, trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      submitForm(formName) {
        var that = this;
        let params ={
          username:this.ruleForm2.emil,
          name:this.ruleForm2.name,
          pwd:this.ruleForm2.pass,
          activecode:this.ruleForm2.activecode,
          phonenumber:this.ruleForm2.phonenumber
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // alert('submit!');
            console.log(params);
            this.$axios({
              method: 'post',
              url: 'UserManager/BackActiveRegest',
              data: params
            })
              .then(res => {
                let data = res.data
                console.log(data)
                console.log(data.isError == 'False')
                if (data.isError == 'False') {
                  var result = data.resultbg;

                  /*that.$message({
                    message: data.errorMessage,
                    type: 'success'
                  });*/

                  that.errorMessage = data.errorMessage;
                  // that.dialogFormVisibledl = true;
                  that.dialogFormVisibledl = true;
                  setTimeout(function () {
                    that.jumpAut();
                  },3000)
                  /*that.$alert(data.errorMessage, '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      this.$message({
                        type: 'info',
                        message: `action: ${ action }`
                      });
                    }
                  });*/
                } else {// 有错误
                  // that.$message.error(data.errorMessage);
                  /*var str = '<h1>'+data.errorMessage+'</h1><p>系统3秒后自动登录</p><p>如无跳转，<a href="javascript:;">点此登录</a></p>'
                  that.$alert(str, '提示', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: action => {
                      this.$message({
                        type: 'info',
                        message: `action: ${ action }`
                      });
                    }
                  });*/

                  that.$message.error(data.errorMessage);

                  /*that.errorMessage = data.errorMessage;
                  that.dialogFormVisibledl = true;
                  setTimeout(function () {
                    that.jumpAut();
                  },3000)*/
                }

              })
              .catch(err => {
                that.$message.error('网络连接失败');
                // this.$store.commit('setDialogConfig', sendData)
              })

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      jumpAut:function(){
        //this.ruleForm2.name
        this.$router.replace({path: 'Authentication', query:{name:this.ruleForm2.name}})
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    },

    created:function(){},
    mounted:function(){
      console.log(this.$route.query.activecode)
      if(this.$route.query!==undefined){
        this.ruleForm2.activecode = this.$route.query.activecode;
        this.ruleForm2.emil = this.$route.query.id;
      }
      console.log(this.ruleForm2)
    }
  }
</script>

<style>

  #Activate div{ overflow: inherit;}
  #Activate { height:calc(100% - 235px); overflow: hidden;}
  #Activate p{padding: 0px;margin: 0px;}
  #Activate .blue .el-form-item__content{color: #4384CF;font-size: 16px; font-weight: bolder;}
  #Activate  .head-center th,.html-center{ text-align: center;}
  #Activate .title {
    font-size: 24px;
    color: #2E2E2E;
    letter-spacing: 0;
    margin: 19px 0 12px 44px;
  }
  #Activate .title:before {
    content: '';
    position: relative;
    display: inline-block;
    font-size: 0;
    width: 6px;
    height: 20px;
    top: 2px;
    left: 0;
    margin-right: 13px;
    background: #04A4FF;
  }
  .content1 {
    width: 100%;
    overflow: hidden;
    background-color: #fff;
    height:calc(100% - 20px) !important;
    min-width: 1190px;
    max-width: 1200px;
    margin: 10px auto;
    overflow-x:hidden ;
  }
  #Activate .line-gray {
    height: 1px;
    background: #EDEDED;
    margin: 0 24px;
  }
  #Activate .el-form-item{ display: inline-flex; margin-right: 12px; }
  .rzData1 .el-form-item__content{ margin-left: 0px !important; width: 300px;}
  #Activate .el-form-item__label{ padding-right: 5px;}
  #Activate .el-message-box__title,.rzData1 .el-dialog__title{font-size: 14px;
    color: #929AAB;}
  #Activate .el-message-box__header,.rzData1 .el-dialog__header{border-bottom: 1px solid #E2E2E2; text-align: left;}
  #Activate .rzData1 .el-dialog__header{ padding: 10px 20px;}
  #Activate .rzData1{ width: 450px; margin: auto; height: 430px; padding-top: 50px;}
  #Activate .info{font-size: 13px;
  color: #949494;}
  #Activate .Danger .el-form-item__label, .red{color: #FF665F;}
  #Activate .loginBord{width: 100%; margin: auto; text-align: center;font-size: 16px;
    color: #838383;}
  #Activate .el-dialog{ width: 460px; height: 268px; margin: auto !important;}
  .loginBord h2{font-size: 22px;
    color: #5599FF;
    text-align: center;
    line-height:40px;}
  .loginBord p{font-size: 16px;
    color: #838383;
    text-align: center; line-height: 28px;}
  .loginBord p a{font-size: 14px;
    color: #5599FF;
    text-align: center;}
</style>



// WEBPACK FOOTER //
// src/components/Activate.vue